<template>
	<div style="overflow:hidden;" class="v-application--wrap">
		<nav>
			<div class="ly__maxWidth__header">
				<v-row dense class="ma-0 pa-0 mt-2 px-7">
                    <template v-if="!barTitle">
                        <v-col cols="8" align-self="baseline" class="bar_selvy_title" >
                            <b>Selvy</b> Checkup
                        </v-col>
                        <v-col cols="4" align-self="center">
                            <img
                                v-if="!hideMenu"
                                src="@/assets/images/renew/ico-profile.svg"
                                style="float: right; width: 28px; z-index: 5;"
                                alt="메뉴버튼"
                                role="button"
                                @click="showNav"
                            />
                        </v-col>
                    </template>
                    
                    <template v-else>
                        <v-col cols="2" class="pa-0 ma-0" align-self="center" >
                            <v-icon @click="goReport" class="bar_selvy_arrow">mdi-arrow-left</v-icon>
                        </v-col>
                        <v-col cols="8" align-self="center" align="center" class="pa-0 ma-0 bar_selvy_title" >
                            {{ barTitle }}
                        </v-col>
                        <v-col cols="2" align-self="center">
                            <img
                                src="@/assets/images/renew/ico-profile.svg"
                                style="float: right; width: 28px;"
                                alt="메뉴버튼"
                                role="button"
                                @click="showNav"
                            />
                        </v-col>
                    </template>
                </v-row>
			</div>
		</nav>
		<div class="ly__maxWidth">
			<router-view></router-view>
		</div>
		<v-fade-transition>
            <div class="navimain" v-if="showrightMenu" @click="closeRightMenu">
                <div class="rightNav" ref="rightMenu" @click.stop="">
                    <div class="user-shape">
                        <img
                            src="@/assets/images/avatar-tall.png"
                            class="avatar_tall"
                            alt="아바타"
                        />
                    </div>
                    <div class="user-text" v-if="getUser.name">
                        {{ getUser.name }}
                        <span class="user-span">{{ getBirthday }} {{ getGender }}</span>
                    </div>
                    <div class="main-checkup" @click="goSample" tabindex="100" role="button">
                        <div class="label1">
                            프리미엄 리포트 보기 >
                        </div>
                    </div>
                    <div class="checkup-start" @click="goHome" tabindex="101" role="button">
                        처음부터 다시하기
                    </div>
                    <template v-if="hasReport">
                        <div class="checkup-result" @click="goReport" tabindex="102" role="button">
                            나의 종합 결과보기
                        </div>
                    </template>
                </div>
            </div>
        </v-fade-transition>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { bus } from "@/main";
import moment from 'moment'

export default {
	name: "checkupLayout",
	data: () => ({
		showrightMenu: false,
        scrollY: 0
	}),
	mounted() {
        window.addEventListener('scroll', () => {
            this.scrollY = window.scrollY
        })
	},
	computed: {
	    hideMenu () {
	        return this.$route.meta.menu === false
        },
        barTitle () {
            if( this.$route.meta.title === null) {
                return false
            } else {
                return this.$route.meta.title
            }
            
        },
		...mapGetters("user", {
            getUser: "getUser",
            getHome: "getHome"
		}),
		...mapGetters("survey", {
            step: "getStep",
            checkupResult: "checkupResult"
		}),
		getBirthday() {
			const birthday = moment(this.getUsbirthday)
			return birthday.format('YYYY.MM.DD')
		},
		getGender () {
			if(this.getUser.gender === "1") {
				return '남'
			}
			else if(this.getUser.gender === "2") {
				return '여'
			}
			return '남'
        },
        hasReport() {
            return this.checkupResult
        },
	},
	methods: {
		showNav() {
			this.showrightMenu = true;
		},
		closeRightMenu() {
			this.showrightMenu = false;
		},
		goHome() {
            this.closeRightMenu()
			this.$router.push('/userTerms')
		},
		goReport() {
            this.closeRightMenu()
			this.$router.push('/checkup/reportOverview')
        },
        goSample() {
            this.closeRightMenu()
            this.$router.push('/checkup/reportSample')
        }
	}
};
</script>

<style lang="scss">
    .ly__maxWidth__header {
        position:fixed; 
        top:0;
        max-width: 500px;
        background: #fff;
        width:100%;
        margin: 0 auto;
        z-index: 1;
        height:52px;
    }
    .ly__maxWidth {
        // height: -moz-available;          /* WebKit-based browsers will ignore this. */
        // height: -webkit-fill-available;  /* Mozilla-based browsers will ignore this. */
        //height: calc(100% - 52px);
        max-width: 500px;
        margin: 52px 0 0 0;
    }

    .btn_ly {
        position: fixed;
        width: 100%;
        bottom: 30px;
        left: 0;
        display: flex;
        justify-content: space-around;
        font-family: "Spoqa Han Sans", sans-serif;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        overflow: hidden;
    }
</style>

<style scoped>
    .progresscontainer {
        position: fixed;
        width: 100%;
        padding: 30px 20px;
        top: 0;
        max-width: 500px;
    }

    .progressbar {
        margin-top: 2px;
        counter-reset: step;
        overflow: hidden;
        width: 85%;
        float: left;
        font-family: "Spoqa Han Sans";
    }
    .progressbar {
        padding: 0;
    }
    .progressbar li {
        float: left;
        width: 9%;
        position: relative;
        list-style: none;
        font-size: 12px;
        line-height: 14px;
        vertical-align: middle;
        text-align: center;
    }
    .progressbar li:before {
        content: counter(step);
        counter-increment: step;
        width: 18px;
        height: 18px;
        border: 1px solid #bebebe;
        display: block;
        margin: 3px auto 8px auto;
        line-height: 18px;
        border-radius: 50%;
        background: white;
        color: #bebebe;
        transition: width 300ms, height 300ms, line-height 300ms, margin 300ms;
    }
    .progressbar li:after {
        content: "";
        position: absolute;
        width: 100%;
        height: 2px;
        background: #979797;
        top: 12px;
        left: -30%;
        z-index: -1;
    }
    .progressbar li:first-child:after {
        content: none;
    }

    .progressbar li.active::after {
        background: #3f6fff;
    }
    .progressbar li.active::before {
        border-color: #3f6fff;
        background: #3f6fff;
        color: white;
        width: 24px;
        height: 24px;
        margin: 0px auto 10px auto;
        line-height: 24px;
        font-weight: bold;
    }
    .progressbar li.previous::after {
        background: #3f6fff;
        width: 18px;
    }
    .progressbar li.previous::before {
        border-color: #3f6fff;
        background: #3f6fff;
        color: white;
        width: 18px;
        height: 18px;
        margin: 3px auto 8px auto;
        line-height: 14px;
    }
    .navimain {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 3;
    }
    .navimain::before {
        content: "";
        height: 100%;
        top: 0;
        position: absolute;
        left: 0;
        right: 300px;
        background-color: rgba(0, 0, 0, 0.32);
        opacity: 0.5;
    }
    .rightNav {
        width: 300px;
        height: 100%;
        top: 0;
        right: 0;
        position: fixed;
        box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.2),
            0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 16px 24px 2px rgba(0, 0, 0, 0.14);
        background-color: #ffffff;
    }

    .main-checkup {
        width: 250px;
        height: 100px;
        border-radius: 2px;
        background: url(~@/assets/images/home-btn-detail.png) no-repeat;
        background-size: cover;
        margin: 21px 20px 0px 20px;
    }

    .label1 {
        font-size: 14px;
        font-weight: bold;
        color: #ffffff;
        position: absolute;
        cursor: pointer;
        font-family: "Spoqa Han Sans";
        line-height: 14px;
        margin: 18px auto 0px 20px;
        border-radius: 2px;
        background-color: #00aeee;
    }

    .user-shape {
        margin: 44px 30px 0px 30px;
    }

    .avatar_tall {
        width: 44px;
        height: 44px;
        object-fit: contain;
    }

    .user-text {
        margin: 10px 25px 21px 25px;
        height: 25px;
        font-family:  "NanumSquare", sans-serif;;
        font-size: 22px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.87);
    }

    .user-span {
        width: 78px;
        height: 20px;
        font-family: "Spoqa Han Sans";
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.43;
        letter-spacing: 0.25px;
        color: rgba(0, 0, 0, 0.6);
    }

    .checkup-start {
        margin: 31px 30px 20px 30px;
        width: 220px;
        height: 24px;
        font-family: "Spoqa Han Sans";
        font-size: 14px;
        font-weight: bold;
        line-height: 24px;
        color: rgba(0, 0, 0, 0.87);
    }

    .checkup-result {
        width: 270px;
        height: 24px;
        font-family: "Spoqa Han Sans";
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 24px;
        letter-spacing: 0.1px;
        color: rgba(0, 0, 0, 0.87);
        margin: 0px 30px 0px 30px;
    }

    @media all and (max-width: 359px) {
        .rightNav {
            width: 290px;
        }
        .navimain::before {
            right: 290px;
        }
    }

    .bar_selvy_title {
        color: #193263 !important;
        font-size:1.2em !important;
        letter-spacing: -0.76px !important;
        font-weight: bolder;
        vertical-align: middle !important;
    }

    .bar_selvy_arrow {
        color: #193263 !important;
        font-size:1.6em !important;
        font-weight: bolder;
        vertical-align: middle !important;
    }
</style>
